

import React, { useState } from "react";
import SectionTitle from "../ConsultancyElements/SectionTitle";
import FAQService from "../../Pages/FAQService";
import { Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";

const { TextArea } = Input;

const UpdateFAQ = () => {
  const [formData, setFormData] = useState({
    id: 0,
    question: "",
    answer: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  // focus states
  const [focus, setFocus] = useState({
    question: false,
    answer: false,
  });

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.question.trim()) newErrors.question = "Question is required";
    if (!formData.answer.trim()) newErrors.answer = "Answer is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setIsSuccess(false);

    try {
      const response = await FAQService.PostUpsertFAQ(formData);
      if (response?.status === 200 || response?.status === 201) {
        setIsSuccess(true);
        message.success(response?.data?.message || "FAQ saved successfully");
        setFormData({ id: 0, question: "", answer: "" });
        navigate("/faq");
      } else {
        message.error("Something went wrong");
      }
    } catch {
      message.error("Failed to save FAQ");
    } finally {
      setLoading(false);
    }
  };

  // dynamic border style
  const inputStyle = (field) => ({
    height: "48px",
    border: errors[field]
      ? "1px solid red"
      : focus[field]
        ? "1px solid #0d6efd"
        : "1px solid #ced4da",
    boxShadow: "none",
    outline: "none",
  });

  const textAreaStyle = (field) => ({
    border: errors[field]
      ? "1px solid red"
      : focus[field]
        ? "1px solid #0d6efd"
        : "1px solid #ced4da",
    boxShadow: "none",
    outline: "none",
  });

  return (
    <section
      className="accordion-section pb-0"
      style={{ backgroundImage: `url(images/background/17.jpg)` }}
    >
      <div className="container">
        <div className="inner-column">
          <SectionTitle
            title="Ask What You Want To Know"
            header="Frequently Asked Questions"
          />

          <div className="row clearfix align-items-center">
            {/* Image */}
            <div className="col-lg-5 col-md-5 col-sm-12">
              <div className="care-imagebox text-center">
                <img src="images/resource/care.png" alt="img" />
              </div>
            </div>

            {/* Form */}
            <div className="accordion accordion-default col-lg-7 col-md-7 col-sm-12">
              <div
                style={{
                  background: "#fff",
                  padding: "30px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  borderLeft: "5px solid #0d6efd",
                }}
              >
                <h4 style={{ fontWeight: "600", marginBottom: "20px" }}>
                  Add New FAQ
                </h4>

                <form onSubmit={handleSubmit}>
                  {/* Question */}
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 600, color: "#0d6efd" }}>
                      Question <span style={{ color: "red" }}>*</span>
                    </label>

                    <Input
                      value={formData.question}
                      placeholder="Enter your question"
                      onChange={(e) =>
                        handleChange("question", e.target.value)
                      }
                      onFocus={() =>
                        setFocus((p) => ({ ...p, question: true }))
                      }
                      onBlur={() =>
                        setFocus((p) => ({ ...p, question: false }))
                      }
                      style={inputStyle("question")}
                    />

                    {errors.question && (
                      <small style={{ color: "red" }}>
                        {errors.question}
                      </small>
                    )}
                  </div>

                  {/* Answer */}
                  <div className="form-group mb-4">
                    <label style={{ fontWeight: 600, color: "#0d6efd" }}>
                      Answer <span style={{ color: "red" }}>*</span>
                    </label>

                    <TextArea
                      rows={5}
                      value={formData.answer}
                      placeholder="Write a clear and helpful answer"
                      onChange={(e) =>
                        handleChange("answer", e.target.value)
                      }
                      onFocus={() =>
                        setFocus((p) => ({ ...p, answer: true }))
                      }
                      onBlur={() =>
                        setFocus((p) => ({ ...p, answer: false }))
                      }
                      style={textAreaStyle("answer")}
                    />

                    {errors.answer && (
                      <small style={{ color: "red" }}>
                        {errors.answer}
                      </small>
                    )}
                  </div>

                  {/* Button */}
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    className="theme-btn btn-style-one"
                    style={{ width: "100%", height: "48px" }}
                  >
                    Save FAQ
                  </Button>



                </form>
              </div>
            </div>

            {/* Footer */}
            <div className="more-query text-center mt-4">
              <p>Still Have More Questions?</p>
              <h6>
                Contact Our <a href="/contact">Expert Support Team</a>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UpdateFAQ;
